import React from 'react';
import { ContentfulThemeApiClient } from '@jbhi-fi/apis/src/contentfulThemeApi/ContentfulThemeApiClient';
import { serviceHelper } from '../../config/service-helper';
import { useContentfulSearchContent } from '@jbhi-fi/components/src/hooks/useContentfulSearchContent/useContentfulSearchContent';
import SearchContentResult from './SearchContentResult';
import { SearchContentTransformer } from '@jbhi-fi/components/src/Contentful/transformers/SearchContentTransformer';

const contentfulClient = new ContentfulThemeApiClient({
  themeApiBaseUrl: serviceHelper.themeApisUrl,
});

export const SearchContentContainer = (searchTerm: { term: string }) => {
  const { searchContentResults = [] } = useContentfulSearchContent({
    contentfulThemeApiClient: contentfulClient,
    searchTerm,
  });
  const getTransformedSearchContentProps = () => {
    return SearchContentTransformer.toSearchContentProps(searchContentResults);
  };

  return <SearchContentResult searchResults={getTransformedSearchContentProps()} searchTerm={searchTerm?.term} />;
};
